import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabaseClient';
import { useTheme } from '../../lib/useTheme';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)' };
const font = "'DM Sans', sans-serif";

export default function AdminNotes({ clientId, adminId }) {
  const t = useTheme();
  const [notes, setNotes] = useState([]);
  const [content, setContent] = useState('');
  const [meetingDate, setMeetingDate] = useState(new Date().toISOString().split('T')[0]);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    if (!clientId) return;
    supabase.from('admin_notes').select('*').eq('client_id', clientId).order('meeting_date', { ascending: false }).then(({ data }) => {
      if (data) setNotes(data);
    });
  }, [clientId, refresh]);

  const addNote = async () => {
    if (!content.trim()) return;
    await supabase.from('admin_notes').insert({ client_id: clientId, admin_id: adminId, content: content.trim(), meeting_date: meetingDate });
    setContent(''); setRefresh(n => n + 1);
  };

  const deleteNote = async (id) => {
    await supabase.from('admin_notes').delete().eq('id', id);
    setRefresh(n => n + 1);
  };

  const inp = { width:'100%', padding:'10px 14px', border:`0.5px solid ${t.border}`, borderRadius:12, fontSize:14, fontFamily:font, background:t.card, color:t.text, outline:'none', boxSizing:'border-box' };

  return (
    <div>
      <p style={{ fontSize:14, fontWeight:500, margin:'0 0 12px' }}>📝 Notas de reunión (privadas)</p>
      <p style={{ fontSize:11, color:t.textSecondary, margin:'0 0 12px' }}>Solo tú ves estas notas. El cliente no tiene acceso.</p>

      {/* Add note */}
      <div style={{ background:t.isDark?'#222':'#f8f8f6', borderRadius:14, padding:14, marginBottom:16 }}>
        <div style={{ display:'flex', gap:8, marginBottom:8 }}>
          <input type="date" value={meetingDate} onChange={e => setMeetingDate(e.target.value)} style={{ ...inp, width:'auto' }} />
        </div>
        <textarea value={content} onChange={e => setContent(e.target.value)} placeholder="Notas de la reunión..." style={{ ...inp, minHeight:80, resize:'vertical' }} />
        <button onClick={addNote} disabled={!content.trim()} style={{ marginTop:8, background:C.logoGrad, color:'#fff', border:'none', borderRadius:50, padding:'8px 20px', fontSize:13, fontWeight:500, cursor:'pointer', fontFamily:font, opacity:content.trim()?1:0.4 }}>Guardar nota</button>
      </div>

      {/* Notes list */}
      {notes.length === 0 && <p style={{ fontSize:13, color:t.textSecondary, textAlign:'center', padding:12 }}>Sin notas aún.</p>}
      {notes.map(note => (
        <div key={note.id} style={{ borderLeft:`3px solid ${C.turquesa}`, paddingLeft:14, marginBottom:16 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:4 }}>
            <span style={{ fontSize:12, fontWeight:600, color:C.turquesa }}>{note.meeting_date}</span>
            <button onClick={() => deleteNote(note.id)} style={{ background:'none', border:'none', color:t.textSecondary, fontSize:14, cursor:'pointer', opacity:0.4 }}>×</button>
          </div>
          <p style={{ fontSize:13, color:t.text, lineHeight:1.6, margin:0, whiteSpace:'pre-wrap' }}>{note.content}</p>
        </div>
      ))}
    </div>
  );
}
